import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table bonus report view.
 * @extends JetView
 */
export default class recordTableBonusReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Main view type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: 'Detalles', // Tooltip text
                    template: function (obj) {
                        // Template for rendering the column
                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Date', header: 'Fecha', width: 150, sort: 'int' }, // Date column
                { id: 'Type', header: 'Tipo', width: 150, sort: 'int' }, // Type column
                {
                    id: 'Amount', // Amount column
                    header: 'Monto', // Column header
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Description', // Description column
                    header: 'Descripción', // Column header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handler for click events
                details: function (euv, id) {
                    // Click event for details icon
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with item
                },
            },
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            tooltip: true, // Enable tooltips
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/Report/GetClientBonusReportDetail', // Data source URL
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = grid.data.url; // Store the grid URL
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID change
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?id=' + idUser); // Load data for the specified user ID
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Attach click event to grid items
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with item
        });
    }
}

// FILE DOCUMENTED
